import React, { useState } from 'react';
import DateTimePicker from './DateTimePicker';

const SimpleDateTimeTest = () => {
  const [selectedDateTime, setSelectedDateTime] = useState(new Date());

  const handleDateTimeChange = (date, isASAP) => {
    setSelectedDateTime(date);
    console.log('Selected DateTime:', date, 'ASAP:', isASAP);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h2>Simple DateTimePicker Test</h2>
      <p>This is a simple test of the DateTimePicker component without external dependencies.</p>
      
      <div style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', margin: '20px 0' }}>
        <DateTimePicker
          value={selectedDateTime}
          onChange={handleDateTimeChange}
          label="Test Date & Time"
          className="mb-3"
          use24Hour={false}
          show24HourToggle={false}
        />
      </div>
      
      <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', marginTop: '20px' }}>
        <h6>Selected DateTime:</h6>
        <p>{selectedDateTime.toLocaleString()}</p>
        <h6>ISO String:</h6>
        <p>{selectedDateTime.toISOString()}</p>
      </div>
    </div>
  );
};

export default SimpleDateTimeTest; 